let module = angular.module('app.resources');

module.factory('ScoreboardAssistFirmware', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/scoreboard-assist/firmware/:id`,
    { id: '@id' },
    {
      version: {
        method: 'GET',
        url: `${API_ROOT}/account/scoreboard-assist/firmware/:id/version`,
        transformResponse: (data) => ({ version: data }),
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/scoreboard-assist-firmware.js